import { getCustomerPlan } from 'src/data/subscription';

export const identifyUser = (user, customer) => {
  const { FS } = window;

  try {
    FS.identify(`User-${user.id}`);
    FS.setUserVars({
      is_keywee_bool: user.isKeywee,
      created_at_date: new Date(user.createdAt),
      customer_id_str: (customer && customer.id) || '-',
      keywee_customer_bool: (customer && customer.isKeywee) || false,
      plan_str: getCustomerPlan(customer) || '-',
    });
  } catch (error) {
    // I want application to not crush, but don't care about the message
  }
};

export const resetUser = () => {
  const { FS } = window;

  try {
    FS.anonymize();
  } catch (error) {
    // I want application to not crush, but don't care about the message
  }
};
